<template>
  <div class="customer-list-container">
    <!-- 客户管理头部 -->
    <el-card class="customer-header-card">
      <div class="header-content">
        <div class="header-left">
          <h2>客户管理</h2>
        </div>
        <div class="header-right">
          <el-button @click="refreshData">
            <i class="el-icon-refresh"></i>
            刷新
          </el-button>
        </div>
      </div>
    </el-card>

    <!-- 搜索和筛选 -->
    <el-card class="filter-card">
      <div class="filter-content">
        <div class="filter-left">
          <el-input
              v-model="searchQuery.keyword"
              placeholder="搜索客户昵称/手机号/会员卡号"
              prefix-icon="el-icon-search"
              style="width: 300px; margin-right: 16px;"
              @keyup.enter.native="handleSearch"
              clearable
              @clear="handleSearch"
          />
        </div>
      </div>
    </el-card>

    <!-- 客户表格 -->
    <el-card class="customer-table-card">
      <div v-loading="loading">
        <el-table
            :data="customerList"
            style="width: 100%"
            :header-cell-style="{background: '#f5f7fa', color: '#606266'}"
        >
          <el-table-column prop="id" label="客户ID" width="80"/>
          <el-table-column prop="cardNumber" label="会员卡号" width="150"/>
          <el-table-column prop="nickname" label="客户昵称" min-width="120">
            <template slot-scope="{row}">
              <div class="customer-name-cell">
                <el-avatar :size="36" :src="row.avatar" class="customer-avatar">
                  {{ (row.nickname || row.userName || '用').charAt(0) }}
                </el-avatar>
                <div class="customer-info">
                  <div class="name">{{ row.nickname || row.userName }}</div>
                  <div class="phone">{{ row.phone || '--' }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="用户名" width="120"/>
          <el-table-column prop="balance" label="账户余额" width="120" align="right">
            <template slot-scope="{row}">
              {{ row.balance !== undefined ? `¥${(row.balance / 100).toFixed(2)}` : '¥0.00' }}
            </template>
          </el-table-column>
          <el-table-column prop="totalRebate" label="累计返利" width="120" align="right">
            <template slot-scope="{row}">
              {{ row.totalRebate ? `¥${(row.totalRebate / 100).toFixed(2)}` : '¥0.00' }}
            </template>
          </el-table-column>
          <el-table-column prop="totalWithdraw" label="累计提现" width="120" align="right">
            <template slot-scope="{row}">
              {{ row.totalWithdraw ? `¥${(row.totalWithdraw / 100).toFixed(2)}` : '¥0.00' }}
            </template>
          </el-table-column>
          <el-table-column prop="greenPoints" label="绿色积分" width="100" align="center"/>
          <el-table-column prop="totalGreenPoints" label="累计积分" width="100" align="center"/>
          <el-table-column prop="inviterClerkName" label="邀请员工" width="120">
            <template slot-scope="{row}">
              {{ row.inviterClerkName || '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="addDataTime" label="注册时间" width="160">
            <template slot-scope="{row}">
              {{ formatTimestamp(row.addDataTime) }}
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
              :current-page="pagination.currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              :total="pagination.total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import api from "@/utils/api"

export default {
  name: 'CustomerList',
  data() {
    return {
      loading: false,
      storeId: null,
      storeName: '',

      searchQuery: {
        keyword: ''
      },

      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },

      customerList: []
    }
  },

  mounted() {
    this.initData()
  },

  methods: {
    async initData() {
      console.log('=== 初始化客户列表 ===')

      this.loading = true

      try {
        // 获取当前管理员信息
        // await this.getCurrentAdminInfo()

        await this.loadCustomerList()
        // if (this.storeId) {
        //   // 如果需要加载店铺名称，可以保留这个调用
        //   // await this.loadStoreInfo()
        //   await this.loadCustomerList()
        // } else {
        //   this.$message.warning('未获取到店铺信息，请联系管理员')
        // }
      } catch (error) {
        console.error('初始化失败:', error)
        this.$message.error('初始化失败，请刷新页面重试')
      } finally {
        this.loading = false
      }
    },

    // 获取当前管理员信息
    // async getCurrentAdminInfo() {
    //   try {
    //     const res = await api.login_getAdminInfo(null, {})
    //     console.log('当前管理员信息:', res)
    //
    //     const responseData = res.data || res
    //     if (responseData.code === '000' && responseData.data) {
    //       const adminInfo = responseData.data
    //       // 根据实际返回的数据结构，字段名是 merchantId
    //       this.storeId = adminInfo.merchantId || null
    //       this.storeName = adminInfo.name || '我的店铺'
    //
    //       console.log('店铺信息:', {
    //         storeId: this.storeId,
    //         storeName: this.storeName,
    //         adminId: adminInfo.id,
    //         adminUsername: adminInfo.username
    //       })
    //     } else {
    //       console.warn('获取管理员信息失败:', responseData.message)
    //       this.$message.error(responseData.message || '获取管理员信息失败')
    //     }
    //   } catch (error) {
    //     console.error('获取管理员信息异常:', error)
    //     this.$message.error('获取管理员信息失败，请刷新重试')
    //   }
    // },

    // 加载店铺信息
    // async loadStoreInfo() {
    //   try {
    //     const res = await api.merchant_getMerchantDetail({ id: this.storeId })
    //     if (res.data.code === '000' && res.data.data) {
    //       this.storeName = res.data.data.name
    //     }
    //   } catch (error) {
    //     console.error('加载店铺信息失败:', error)
    //     this.storeName = this.storeName || '我的店铺'
    //   }
    // },

    // 加载客户列表 - 通过 getUserListByMerchantId
    async loadCustomerList() {
      // if (!this.storeId) {
      //   console.warn('没有店铺ID，无法加载客户列表')
      //   return
      // }

      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          search: this.searchQuery.keyword || ''
        }

        console.log('请求参数:', params)

        const res = await api.adminUser_getUserListByAdminId(params, null)
        console.log('客户列表响应:', res)

        const responseData = res.data || res
        if (responseData.code === '000' && responseData.data) {
          const pageData = responseData.data
          this.customerList = pageData.list || pageData.records || []
          this.pagination.total = pageData.total || pageData.totalCount || 0

          console.log(`加载成功: ${this.customerList.length} 条记录, 总计 ${this.pagination.total} 条`)
        } else {
          console.error('接口返回错误:', responseData)
          this.$message.error(responseData.message || '加载客户列表失败')
          this.customerList = []
          this.pagination.total = 0
        }
      } catch (error) {
        console.error('加载客户列表失败:', error)
        this.$message.error('加载客户列表失败')
        this.customerList = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadCustomerList()
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.currentPage = 1
      this.loadCustomerList()
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.loadCustomerList()
    },

    // 刷新数据
    refreshData() {
      this.pagination.currentPage = 1
      this.searchQuery.keyword = ''
      this.loadCustomerList()
    },

    // 格式化时间戳
    formatTimestamp(timestamp) {
      if (!timestamp) return '--'
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      const second = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  }
}
</script>

<style scoped lang="scss">
.customer-list-container {
  padding: 20px;
}

.customer-header-card {
  margin-bottom: 20px;

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header-left {
    h2 {
      margin: 0 0 12px 0;
      font-size: 24px;
      color: #303133;
    }

    .store-info {
      .store-name {
        font-size: 16px;
        color: #606266;
        font-weight: 500;
        margin-right: 12px;
      }
    }
  }
}

.filter-card {
  margin-bottom: 20px;

  .filter-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .filter-left {
    display: flex;
    align-items: center;
  }
}

.customer-table-card {
  .customer-name-cell {
    display: flex;
    align-items: center;

    .customer-avatar {
      margin-right: 12px;
      background-color: #67c23a;
      color: white;
      font-weight: bold;
    }

    .customer-info {
      .name {
        font-weight: 500;
        margin-bottom: 4px;
      }

      .phone {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

@media (max-width: 768px) {
  .customer-list-container {
    padding: 12px;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 16px;
  }

  .filter-content {
    flex-direction: column;
    align-items: stretch !important;
    gap: 16px;
  }

  .filter-left {
    flex-direction: column;
    align-items: stretch !important;

    :deep(.el-input),
    :deep(.el-select) {
      width: 100% !important;
      margin-right: 0 !important;
      margin-bottom: 12px;
    }
  }
}
</style>